module.exports = __webpack_public_path__ + "static/media/cart.91456d97.svg";